import React from 'react'
import Slider from 'react-slick'
import './SliderBasic.scss'
import {map} from 'lodash'
import db, { storage } from '../../utils/firebase'
import {BrowserRouter as Router, withRouter } from 'react-router-dom'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import SliderTerror from './SliderTerror'
import {connect, } from 'react-redux'
import { useAuth } from '../../context/authContext'




 function SliderBasic({data,titleSlider}) {




    const detalle = navigator.userAgent
                        let regExp = /android|iphone|kindle|ipad/i;
                        let isMobile = regExp.test(detalle)
 

    

    


  
    const setting = {
      //dots: true,
      speed: 1000,
      slidesToShow: isMobile ? 3 : 4,
      slidesToScroll: isMobile ? 2 : 4,
      Infinity,

    }
    
    
    



    return (
        
        
        
        <div className="basic-slider-item" >
            <h3>{titleSlider}</h3>
            <Slider {...setting} >
                {
                    map(data, item =>(
                        <RenderSlider key={item.id} item={item}  />
                        
                        ))
                    }
                                     

            </Slider>
               
        </div>
        
    )
}




export default  SliderBasic

function RenderSlider(props){
    
    const {item}=props

    

    
    return(
        
        <div className="basic-slider-item__list" >
            <Link to={`/${item?.temporadas ?"serie":"pelicula"}/${item.uuidPoster}` } key={item.id} >
            
                <div 
                    className="avatar"
                    style={{backgroundImage: `url('${item.urlPoster}')`}}
                    />
                <h2>{item.title}</h2>
            </Link>
        </div>
    )
}